import { render } from "./IconTick.vue?vue&type=template&id=72bb9c09"
import script from "./IconTick.vue?vue&type=script&lang=js"
export * from "./IconTick.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__